const { REACT_APP_PEXELS, REACT_APP_OAUTH, REACT_APP_BASE_URL } = process.env;

export default class ConfigService {
	static PexelsUrl = "https://api.pexels.com/v1";
	static PexelsToken = REACT_APP_PEXELS;
	static OauthUrl = REACT_APP_OAUTH;
	static ApiUrl = REACT_APP_BASE_URL;
	static maxLength = 200;
}
